import { render, staticRenderFns } from "./ProfileAssignmentPage.vue?vue&type=template&id=405d954f&lang=pug"
import script from "./ProfileAssignmentPage.vue?vue&type=script&lang=js"
export * from "./ProfileAssignmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('405d954f')) {
      api.createRecord('405d954f', component.options)
    } else {
      api.reload('405d954f', component.options)
    }
    module.hot.accept("./ProfileAssignmentPage.vue?vue&type=template&id=405d954f&lang=pug", function () {
      api.rerender('405d954f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/user_profiles/ProfileAssignmentPage.vue"
export default component.exports